import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CadensSharedModule } from '../../shared';
import { DialogModule } from 'primeng/primeng';

import {
    EntityAuditEventService,
    EntityAuditEventComponent,
    EntityAuditEventDetailComponent,
    entityAuditEventRoute,
    EntityAuditEventResolvePagingParams,

} from './';
import {CadensBlocksModule} from '../blocks/blocks.module';

let ENTITY_STATES = [
    ...entityAuditEventRoute
];

@NgModule({
    imports: [
        CadensSharedModule,
        DialogModule,
        CadensBlocksModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        EntityAuditEventComponent,
        EntityAuditEventDetailComponent
    ],
    entryComponents: [
        EntityAuditEventComponent
    ],
    providers: [
        EntityAuditEventService,
        EntityAuditEventResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensEntityAuditEventModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/entity-audit-event/entity-audit-event.module.ts